export default __webpack_public_path__ + "static/media/flip.613b50d0.wav";